var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 0.666992H5.99333C5.26 0.666992 4.66667 1.26699 4.66667 2.00033H11.3333C12.0667 2.00033 12.6667 2.60033 12.6667 3.33366V12.0003L14 12.667V2.00033C14 1.26699 13.4 0.666992 12.6667 0.666992ZM10 4.66699V13.3137L7.19333 12.107L6.66667 11.8803L6.14 12.107L3.33333 13.3137V4.66699H10ZM3.33333 3.33366H10C10.7333 3.33366 11.3333 3.93366 11.3333 4.66699V15.3337L6.66667 13.3337L2 15.3337V4.66699C2 3.93366 2.6 3.33366 3.33333 3.33366Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.58cb3c1f69ae278b0ba693c7d34addd3.svg";
export { ForwardRef as ReactComponent };